module.exports = __webpack_public_path__ + "img/building.1bba4f37.svg";